export class TransactionDTO {
  id: number;
  paymentIntentId?: string;
  stockistId: number;
  cardId: number;
  amount: number;
  vat: number;
  result: TransactionResult;

  constructor(data: {
    id: number,
    paymentIntentId?: string,
    stockistId: number,
    cardId: number,
    amount: number,
    vat: number,
    result: TransactionResult
  }) {
    this.id = data.id;
    this.paymentIntentId = data.paymentIntentId;
    this.stockistId = data.stockistId;
    this.cardId = data.cardId;
    this.amount = data.amount;
    this.vat = data.vat;
    this.result = data.result;
  }
}

export enum TransactionResult {
  PreOrder = 0,
  Processing = 1,
  Failed = 2,
  Succeeded = 3,
  PendingAutoRenew = 4,
  Refunded = 5,
  SucceededNoEmail = 6
}